// routes
import { PATH_AllPages, PATH_HelpAndCommunication } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
import AppCache from '../../../services/appcache';
// --------------------------------------------------------------------------------------------------------

const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />);

const ICONS = {
    dataUpload: icon('ic_dataupload'),
    dataMapping: icon('ic_mapping'),
    enablereupload: icon('ic_reupload'),
    dashboard: icon('ic_dashboard'),
    master: icon('ic_master'),
    report: icon('ic_chart'),
    reprocess: icon('ic_reprocess'),
    helpdesk: icon('communication'),
    data: icon('ic_data'),
    topic: icon('ic_topic'),
    cart: icon('category'),
    tags: icon('tag')
};

const userDetails = AppCache.GetUserLoginDetails();
const hasZylemFranchise = userDetails?.Franchise?.split(',')
    .some(f => f.trim().toUpperCase() === 'ETHICON' || f.trim().toUpperCase() === 'ENDO');

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
            { title: 'Data Upload Status', path: PATH_AllPages.dataUploadApprove, icon: ICONS.dataUpload },
            { title: 'My Dealers Dashboard', path: PATH_AllPages.dealerlistpage, icon: ICONS.dashboard },
            ...(hasZylemFranchise ? [
                { title: 'Reload Zylem Data', path: PATH_AllPages.reloadzylemdata, icon: ICONS.reprocess },
                { title: 'Data Mapping', path: PATH_AllPages.datamapping, icon: ICONS.dataMapping }
            ] : []),
            { title: 'Enable Reupload', path: PATH_AllPages.enablereupload, icon: ICONS.enablereupload },
            { title: 'Configuration', path: PATH_AllPages.configuration, icon: ICONS.master },
            { title: 'System Configuration ', path: PATH_AllPages.cutoffdatepage, icon: ICONS.master },
            { title: 'Help Topics', path: PATH_AllPages.helptopics, icon: ICONS.topic },
            { title: 'Help Category', path: PATH_AllPages.helpcategory, icon: ICONS.cart },
            { title: 'Sub Category', path: PATH_AllPages.subcategory, icon: ICONS.enablereupload },
            { title: 'Tags', path: PATH_AllPages.tags, icon: ICONS.tags },

            { title: 'Help and Communication', path: PATH_HelpAndCommunication.helpandcommunication('JJ Core'), opneinnewtab: true, icon: ICONS.helpdesk },
            {
                title: 'Masters', path: PATH_AllPages.master.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor', path: PATH_AllPages.master.distributor },
                    { title: 'Products', path: PATH_AllPages.master.product },
                    { title: 'ECP Product', path: PATH_AllPages.master.ecpproduct },
                    { title: 'Standard Price', path: PATH_AllPages.master.standardpricemaster },
                    { title: 'Accounts', path: PATH_AllPages.master.account },
                    { title: 'Area Tree', path: PATH_AllPages.master.areatree },
                    { title: 'Surgeons', path: PATH_AllPages.master.surgeon },
                    { title: 'Employee', path: PATH_AllPages.master.empmaster },
                    { title: 'Territory', path: PATH_AllPages.master.territory },
                    { title: 'Employee Territory', path: PATH_AllPages.master.empterritory },
                    { title: 'Territory Management', path: PATH_AllPages.master.accountterritory },
                    { title: 'Branch Secretary Region', path: PATH_AllPages.master.empregion },
                    { title: 'Distributor Territory', path: PATH_AllPages.master.distributorterritory },
                    { title: 'Territory Hierarchy', path: PATH_AllPages.master.territoryhierarchy },
                    { title: 'Organization Group ', path: PATH_AllPages.master.orggroupdefinition },
                    { title: 'Dealer Agreement', path: PATH_AllPages.master.dealeragreementexpiry },
                    { title: 'Dealer Rating ', path: PATH_AllPages.master.dealerrating },
                    { title: 'Distributor Billing Software', path: PATH_AllPages.master.distributorbillingsoftware },
                    { title: 'Customer', path: PATH_AllPages.master.customers },
                    { title: 'Customer Account', path: PATH_AllPages.master.customeraccount },
                ],
            },
            {
                title: 'Allied Master', path: PATH_AllPages.alliedmaster.root, icon: ICONS.master,
                children: [
                    { title: 'Distributor Group', path: PATH_AllPages.alliedmaster.distributorgroup },
                    { title: 'UOM', path: PATH_AllPages.alliedmaster.uom },
                    { title: 'Franchise', path: PATH_AllPages.alliedmaster.franchise },
                    { title: 'Sub Franchise', path: PATH_AllPages.alliedmaster.subfranchise },
                    { title: 'Product Group', path: PATH_AllPages.alliedmaster.productgroup },
                    { title: 'Product category', path: PATH_AllPages.alliedmaster.productcategory },
                    { title: 'Product Brand', path: PATH_AllPages.alliedmaster.productbrand },
                    { title: 'Product Line', path: PATH_AllPages.alliedmaster.productline },
                    { title: 'Account Group', path: PATH_AllPages.alliedmaster.accountgroup },
                    { title: 'Account Type', path: PATH_AllPages.alliedmaster.accounttype },
                    { title: 'Account Classification', path: PATH_AllPages.alliedmaster.accountclassification },
                    { title: 'Account Segmentation', path: PATH_AllPages.alliedmaster.accountsegmentation },
                    { title: 'Account Category', path: PATH_AllPages.alliedmaster.accountcategory },
                    { title: 'Surgeon Contact Type', path: PATH_AllPages.alliedmaster.surgeoncontacttype },
                    { title: 'Surgeon Sub Contact Type', path: PATH_AllPages.alliedmaster.surgeonsubcontacttype },
                    { title: 'City Tier', path: PATH_AllPages.alliedmaster.citytier },
                    { title: 'Employee Level', path: PATH_AllPages.alliedmaster.emplevel },
                    { title: 'Specialist', path: PATH_AllPages.alliedmaster.specialist },
                    { title: 'Bravo Hierarchy', path: PATH_AllPages.alliedmaster.bravohierarchy },
                ],
            },
            {
                title: 'Data', path: PATH_AllPages.data.root, icon: ICONS.data,
                children: [
                    { title: 'Inventory', path: PATH_AllPages.data.inventorypage },
                    // { title: 'Gross Sales', path: PATH_AllPages.data.grosssalepage },
                ],
            },
            {
                title: 'Report', path: PATH_AllPages.report.root, icon: ICONS.report,
                children: [
                    { title: 'Dealer Data Status Report', path: PATH_AllPages.report.dealerdatastatusreportpage },
                    { title: 'Dealer Reported Sales', path: PATH_AllPages.report.transactionreportpage },
                    { title: 'Dealer Reported SNS', path: PATH_AllPages.report.dealerreportedsnsreportpage },
                    { title: 'Dealer Price Report', path: PATH_AllPages.report.dealerreportpage },
                    { title: 'Dump Report', path: PATH_AllPages.report.territorydumpreportpage },
                    { title: 'Dealer Purchase Report', path: PATH_AllPages.report.dealerpurchasereportpage },
                    { title: 'Activity Log', path: PATH_AllPages.report.activitylogpage },
                    { title: 'Inventory Report', path: PATH_AllPages.report.inventoryreportpage },
                    { title: 'Standard Price Report', path: PATH_AllPages.report.standardpricereportpage },
                    { title: 'Module Role Access List', path: PATH_AllPages.report.moduleroleaccesslistpage },
                    { title: 'Request Report', path: PATH_AllPages.report.ytddumpreportpage },
                ],
            },
        ],
    }
];

export default navConfig;